module.exports = __webpack_public_path__ + "media/images/icon/icon_sg-a22ac530fc8da0089ff97afb3a76b54a.png";